import { useAuthenticatedQuery, useAuthenticatedQueries } from "@l2r-front/l2r-auth"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"

import { API_MODULE_ROADWAY } from "../../constants/appRoad"

export function useRoadQuery(
    url,
    queryKey,
    queryParameters,
    config = {},
    initialData,
) {
    const apiUrl = `road/${url}`
    const { enabled = true } = config
    const { selectedNetwork } = useNetworksStateContext()
    queryKey.push({ network: selectedNetwork?.slug })

    return useAuthenticatedQuery(
        apiUrl,
        queryKey,
        { ...queryParameters, project: selectedNetwork?.slug },
        {
            ...config,
            enabled: !!selectedNetwork?.slug && selectedNetwork?.modules?.includes(API_MODULE_ROADWAY) && enabled,
        },
        initialData,
    )
}

export function useRoadQueries(queriesData) {
    const { selectedNetwork } = useNetworksStateContext()

    const overridedQueriesData = queriesData.map(queryData => {
        queryData.queryKey.push({ network: selectedNetwork?.slug })
        const { enabled = true } = queryData.config
        const newConfig = {
            ...queryData.config,
            enabled: !!selectedNetwork?.slug && enabled,
        }

        return {
            url: `road/${queryData.url}`,
            queryKey: queryData.queryKey,
            queryParameters: { ...queryData.queryParameters, project: selectedNetwork?.slug },
            ...newConfig,
        }
    })

    return useAuthenticatedQueries(overridedQueriesData)
}